/**
 * Converts a time string to PT format
 * @param time The time to convert to PT format
 * @returns The time in PT format
 *
 * @example
 * ```ts
 * timeToPTFormat('1:30'); // 'PT0H1M30S'
 * timeToPTFormat('1:30:45'); // 'PT1H30M45S'
 * ```
 */
export const timeToPTFormat = (time: string): string => {
	const parts = time.split(':').map(Number);
	let hours = 0;
	let minutes = 0;
	let seconds = 0;

	switch (parts.length) {
		case 3:
			[hours, minutes, seconds] = parts;
			break;
		case 2:
			[minutes, seconds] = parts;
			break;
		default:
			throw new Error('Invalid time format');
	}

	return `PT${hours}H${minutes}M${seconds}S`;
};
